export enum actionTypes {
  CHANGE_ROUTE = 'CHANGE_ROUTE',
  USER_LOGOUT = 'USER_LOGOUT',
  LOGIN = 'LOGIN',
  CONFIRM = 'CONFIRM',
  CREATE_COMPANY = 'CREATE_COMPANY',
  GET_COMPANIES = 'GET_COMPANIES',
  GET_JOURNAL = 'GET_JOURNAL',
  GET_CASH = 'GET_CASH',
  GET_CAPITAL = 'GET_CAPITAL',
  GET_BANK = 'GET_BANK',
  GET_LAND = 'GET_LAND',
  GET_EXPENSES = 'GET_EXPENSES',
  GET_SALES = 'GET_SALES',
  GET_STOCK = 'GET_STOCK',
  GET_CASH_BOOK = 'GET_CASH_BOOK',
  GET_MACHINE = 'GET_MACHINE',
  GET_VEHICLE = 'GET_VEHICLE',
}
